import { put } from "redux-saga/effects";
import { TherapyApi } from "../api";
import { constant } from "../constant";
import MatchingQuestionnaireApi from "../api/MatchingQuestionnaireApi";

// workers
function* getTherapySagaAction(param) {
  try {
    const loading = {
      type: constant.SET_LOGIN_LOADER,
      payload: true,
    };
    yield put(loading);
    const res = yield TherapyApi.getTherapyIndex();
    if (res.status === 200) {
      if (res?.data?.user_form_submission) {
        window.localStorage.setItem(
          "submission_id",
          res?.data?.user_form_submission.id
        );

        window.localStorage.setItem(
          "user_form_submission",
          JSON.stringify({
            submission_id: res?.data?.user_form_submission.id,
            submission_type: res?.data?.user_form_submission?.selected_method,
          })
        );

        const getRecommendInstructor =
          yield MatchingQuestionnaireApi.topMatchesTherapistV2(
            res?.data?.user_form_submission.id
          );
        if (getRecommendInstructor?.data) {
          const updatedObj = {
            ...res?.data,
            recommended_instructors:
              getRecommendInstructor?.data ?? [],
          };
          const payload = {
            type: constant.GET_THERAPY_INDEX_SUCCESS,
            result: updatedObj,
          };
          yield put(payload);
        }
        // if (getRecommendInstructor?.data?.top_matches) {
        //   const updatedObj = {
        //     ...res?.data,
        //     recommended_instructors:
        //       getRecommendInstructor?.data?.top_matches ?? [],
        //   };
        //   const payload = {
        //     type: constant.GET_THERAPY_INDEX_SUCCESS,
        //     result: updatedObj,
        //   };
        //   yield put(payload);
        // }
         else {
          const payload = {
            type: constant.GET_THERAPY_INDEX_SUCCESS,
            result: res.data,
          };
          yield put(payload);
        }
      } else {
        const payload = {
          type: constant.GET_THERAPY_INDEX_SUCCESS,
          result: res.data,
        };
        yield put(payload);
      }
    } else {
      const payload = {
        type: constant.GET_THERAPY_INDEX_FAILED,
        errMsg: "Invalid questionnaire",
      };
      yield put(payload);
    }
  } catch (error) {
    if (error.response) {
      const payload = {
        type: constant.GET_THERAPY_INDEX_FAILED,
        errMsg: error?.data?.detail,
      };
      yield put(payload);
    }
  } finally {
    const loader = {
      type: constant.SET_LOGIN_LOADER,
      payload: false,
    };
    yield put(loader);
  }
}

export { getTherapySagaAction };
